import { Button, Divider, Menu, MenuItem, MenuList, Stack, Typography } from '@mui/material'
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state'
import { Fragment } from 'react/jsx-runtime'
import { DescriptionOutlined, KeyboardArrowDownRounded, RemoveRedEyeRounded } from '@mui/icons-material'
import { SPACING } from '@common/theme/spacing'
import FormRendererDialog from '@features/subject/components/FormRendererDialog'
import { useState } from 'react'

export default function EFormPopupMenuList({
  eForm,
  eFormSubmission,
}: {
  eForm: string | null
  eFormSubmission: string | null | undefined
}) {
  const [open, setOpen] = useState(false)
  return (
    <Fragment>
      <PopupState variant="popover">
        {(popupState) => (
          <Fragment>
            <Button
              variant="outlined"
              sx={{
                paddingX: 0,
                paddingY: 0,
                color: 'text.primary',
                borderColor: 'divider',
              }}
              {...bindTrigger(popupState)}
            >
              <Stack direction="row" alignItems="center">
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={SPACING.minSpacing}
                  paddingX={SPACING.popupMenuSpacingX}
                  paddingY={SPACING.PopupMenuSpacingY}
                >
                  <DescriptionOutlined />
                  <Typography variant="button">eForm</Typography>
                </Stack>
                <Divider orientation="vertical" flexItem />
                <Stack
                  direction="row"
                  alignItems="center"
                  paddingX={SPACING.minSpacing}
                  paddingY={SPACING.PopupMenuSpacingY}
                >
                  <KeyboardArrowDownRounded />
                </Stack>
              </Stack>
            </Button>
            <Menu
              {...bindMenu(popupState)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              data-testid="popup-menu-list"
            >
              <MenuList
                sx={{
                  width: 220,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  paddingY: 0.5,
                  outline: 'none',
                }}
              >
                <MenuItem
                  sx={{
                    height: 36,
                    width: '100%',
                    paddingY: 0.5,
                  }}
                  onClick={() => {
                    setOpen(true)
                    popupState.close()
                  }}
                  data-testid="popup-menu-list-item-reopen"
                >
                  <Stack direction="row" spacing={SPACING.popupMenuIconSpacing} alignItems="center">
                    <RemoveRedEyeRounded
                      sx={{
                        color: 'text.secondary',
                      }}
                    />
                    <Typography>Preview</Typography>
                  </Stack>
                </MenuItem>
              </MenuList>
            </Menu>
          </Fragment>
        )}
      </PopupState>
      {open && (
        <FormRendererDialog
          header="Timepoint eForm"
          onClose={() => setOpen(false)}
          fields={eFormSubmission}
          values={eForm}
          onSubmit={() => {}}
          readOnly={true}
        />
      )}
    </Fragment>
  )
}
